/**
 * Safe jQuery selectors
 *
 * Provide expected nr of results and if it's different throw an Error
 * @example
 *
 * $.fn.findOneInDocument('#test') // expect exactly one element
 * $.fn.findManyInDocument('.test') // expect at least one element
 * $.fn.findNInDocument(3, '.test') // expect exact number of elements given in first param
 * $.fn.findAnyInDocument('.test') // expect any number of results including 0 what is explicitly defined with Any
 *
 * $('#container').findOne('#element');
 * or better:
 * $.fn.findOneInDocument('#container').findOne('#element');
 */

App.namespace('es6.jquery_safe_selectors', () => {
  const assertMany = ($results) => {
    if ($results.length === 0) {
      throw new Error(`Expected selector to return more than 0 elements, got: ${$results.length}`);
    }
  };

  const assertLength = ($results, count) => {
    if ($results.length !== count) {
      throw new Error(`Expected selector to return ${count} element, got: ${$results.length}`);
    }
  };

  const validateContainerNotEmpty = (_this) => {
    if (_this.length === 0) {
      throw new Error('Find function called on empty jQuery element!');
    }
  };

  const _findOne = ($element, selector) => {
    const $results = $element.find(selector);
    assertLength($results, 1);

    return $results;
  };

  $.fn.findOne = function findOne(selector) {
    validateContainerNotEmpty(this);
    return _findOne(this, selector);
  };

  $.fn.findOneInDocument = function findOneInDocument(selector) {
    return _findOne(this.constructor(window.document), selector);
  };

  const _findMany = ($element, selector) => {
    const $results = $element.find(selector);
    assertMany($results);

    return $results;
  };

  $.fn.findMany = function findMany(selector) {
    validateContainerNotEmpty(this);
    return _findMany(this, selector);
  };

  $.fn.findManyInDocument = function findManyInDocument(selector) {
    return _findMany(this.constructor(window.document), selector);
  };

  const _findAny = ($element, selector) => {
    return $element.find(selector);
  };

  $.fn.findAny = function findAny(selector) {
    validateContainerNotEmpty(this);
    return _findAny(this, selector);
  };

  $.fn.findAnyInDocument = function findAnyInDocument(selector) {
    return _findAny(this.constructor(window.document), selector);
  };

  const _findN = ($element, selector) => {
    return $element.find(selector);
  };

  $.fn.findN = function findN(count, selector) {
    if (typeof count !== 'number') {
      throw new Error('findOne first parameter must be an int');
    }

    validateContainerNotEmpty(this);
    return _findN(this, selector);
  };

  $.fn.findNInDocument = function findNInDocument(count, selector) {
    if (typeof count !== 'number') {
      throw new Error('findOne first parameter must be an int');
    }

    return _findN(this.constructor(window.document), selector);
  };
});
